export const ADMIN_COMMUNITY = 'ADMIN_COMMUNITY';
export const ADMIN_BASIC = 'ADMIN_BASIC';
export const ADMIN = 'ADMIN';
export const AFFILIATE_I = 'AFFILIATE_I';
export const AFFILIATE_II = 'AFFILIATE_II';
export const AGENT = 'AGENT';
export const CREDIT_ADMIN = 'CREDIT_ADMIN';
export const CREDIT_CONTROL = 'CREDIT_CONTROL';
export const DEVELOPER_HEADQUARTERS = 'DEVELOPER_HEADQUARTERS';
export const DEVELOPER_BRANCH_LEADER = 'DEVELOPER_BRANCH_LEADER';
export const DEVELOPER_BRANCH_LEADER_SUPERVISOR = 'DEVELOPER_BRANCH_LEADER_SUPERVISOR';
export const DEVELOPER_BRANCH_LEADER_SUPERVISOR_II = 'DEVELOPER_BRANCH_LEADER_SUPERVISOR_II';
export const DEVELOPER_TEAM_LEADER = 'DEVELOPER_TEAM_LEADER';
export const DEVELOPER_EXECUTIVE = 'DEVELOPER_EXECUTIVE';
export const DEVELOPER_SITEPLAN = 'DEVELOPER_SITEPLAN';
export const DEVELOPER_AGENCY_ADMIN = 'DEVELOPER_AGENCY_ADMIN';
export const DEVELOPER_AGENT_LEADER = 'DEVELOPER_AGENT_LEADER';
export const HEADQUARTERS = 'HEADQUARTERS';
export const FINANCE_EXECUTIVE = 'FINANCE_EXECUTIVE';
export const LAWYER = 'LAWYER';
export const LAWYER_HEADQUARTERS = 'LAWYER_HEADQUARTERS';
export const MARKETPLACE_AGENT = 'MARKETPLACE_AGENT';
export const MORTGAGE_BANKER = 'MORTGAGE_BANKER';
export const SUPER_ADMIN = 'SUPER_ADMIN';
export const TEAM_LEADER = 'TEAM_LEADER';

export const ALL_ACCESS_GROUPS = <const>[
  ADMIN_COMMUNITY,
  ADMIN_BASIC,
  ADMIN,
  AGENT,
  CREDIT_ADMIN,
  CREDIT_CONTROL,
  DEVELOPER_HEADQUARTERS,
  DEVELOPER_BRANCH_LEADER,
  DEVELOPER_BRANCH_LEADER_SUPERVISOR,
  DEVELOPER_BRANCH_LEADER_SUPERVISOR_II,
  DEVELOPER_TEAM_LEADER,
  DEVELOPER_EXECUTIVE,
  DEVELOPER_SITEPLAN,
  DEVELOPER_AGENCY_ADMIN,
  DEVELOPER_AGENT_LEADER,
  HEADQUARTERS,
  FINANCE_EXECUTIVE,
  LAWYER,
  LAWYER_HEADQUARTERS,
  MARKETPLACE_AGENT,
  MORTGAGE_BANKER,
  SUPER_ADMIN,
  TEAM_LEADER,
];

export const VALID_GROUPS = [
  SUPER_ADMIN,
  ADMIN_COMMUNITY,
  ADMIN_BASIC,
  ADMIN,
  HEADQUARTERS,
  MORTGAGE_BANKER,
  TEAM_LEADER,
  DEVELOPER_HEADQUARTERS,
  DEVELOPER_BRANCH_LEADER,
  DEVELOPER_BRANCH_LEADER_SUPERVISOR,
  DEVELOPER_BRANCH_LEADER_SUPERVISOR_II,
  DEVELOPER_TEAM_LEADER,
  DEVELOPER_EXECUTIVE,
  DEVELOPER_SITEPLAN,
  DEVELOPER_AGENCY_ADMIN,
  DEVELOPER_AGENT_LEADER,
  AFFILIATE_I,
  AFFILIATE_II,
];

export const ALLOWED_GROUPS = [
  SUPER_ADMIN,
  ADMIN_COMMUNITY,
  ADMIN_BASIC,
  ADMIN,
  DEVELOPER_HEADQUARTERS,
  DEVELOPER_BRANCH_LEADER,
  DEVELOPER_BRANCH_LEADER_SUPERVISOR,
  DEVELOPER_BRANCH_LEADER_SUPERVISOR_II,
  DEVELOPER_TEAM_LEADER,
  DEVELOPER_EXECUTIVE,
  DEVELOPER_SITEPLAN,
  DEVELOPER_AGENCY_ADMIN,
  DEVELOPER_AGENT_LEADER,
  AFFILIATE_I,
  AFFILIATE_II,
];

export const UPPER_GROUPS = [
  ADMIN,
  SUPER_ADMIN,
  DEVELOPER_HEADQUARTERS,
  DEVELOPER_BRANCH_LEADER,
  DEVELOPER_BRANCH_LEADER_SUPERVISOR,
  DEVELOPER_BRANCH_LEADER_SUPERVISOR_II,
];

export function hasAllowedGroups(groups: string[]) {
  return (
    Array.isArray(groups)
    && groups.length > 0 && groups.some((ag) => ALLOWED_GROUPS.some((g) => g === ag))
  );
}

export function hasUpperGroups(groups: string[]) {
  return (
    Array.isArray(groups)
    && groups.length > 0 && groups.some((ug) => UPPER_GROUPS.some((g) => g === ug))
  );
}
